import { computed } from 'vue'

export const useSeller = () => {
  if (!window.env.WEB_STORE_ID) {
    const error = new Error('Web store id required in configuration')
    throw error
  }

  return computed(() => ({ id: window.env.WEB_STORE_ID!, name: 'Jardiland Web' }))
}
